import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SearchPreferredFreelancers } from './search-preferred-freelancers.model';

export interface GenerateSearchPreferredFreelancerOptions {
  readonly id?: number;
  readonly username: string;
  readonly isOnline?: boolean;
  readonly country?: string;
  readonly skills?: readonly number[];
}
export function generateSearchPreferredFreelancerObject({
  id = generateId(),
  username,
  isOnline = false,
  country = 'Australia',
  skills = [1, 2, 3],
}: GenerateSearchPreferredFreelancerOptions): SearchPreferredFreelancers {
  return {
    id,
    country,
    username,
    isOnline,
    skills,
  };
}

export function generateSearchPreferredFreelancerObjects(
  searchPreferredFreelancers: readonly SearchPreferredFreelancers[],
): readonly SearchPreferredFreelancers[] {
  return [...searchPreferredFreelancers];
}
